export const openAiModels = [
  // o-series reasoning models
  'o4-mini',
  'o3-pro',
  'o3-mini',
  'o3',
  'o1-pro',
  'o1-mini',
  'o1',

  // GPT-4.1 family
  'gpt-4.1-nano',
  'gpt-4.1-mini',
  'gpt-4.1',

  // GPT-4o / legacy
  'gpt-4o',
  'gpt-4',

  // GPT-5 system (fast + thinking)
  'gpt-5',
  'gpt-5-thinking',
  'gpt-5-thinking-mini',
  'gpt-5-thinking-nano',

  // Open-weight / local deployable models
  'gpt-oss-120b',
  'gpt-oss-20b',
];
